var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.581 2.94a2.633 2.633 0 00-1.856-1.86C17.087.64 10.52.64 10.52.64s-6.567 0-8.206.438A2.628 2.628 0 00.458 2.937C.02 4.577.02 8 .02 8s0 3.421.438 5.06a2.632 2.632 0 001.856 1.858c1.639.44 8.206.44 8.206.44s6.567 0 8.205-.44a2.628 2.628 0 001.856-1.858C21.02 11.42 21.02 8 21.02 8s0-3.422-.439-5.06zm-12.147 8.2V4.86l5.437 3.117-5.437 3.164z",
    fill: "#0E0E0E"
  })));
}
export default SvgYoutube;